import type { FC } from 'react';

import type { FilterConfig } from '@/productDiscovery/Listings/interfaces/filterConfig';

import { FilterBlock } from '../FilterBlock';
import { EcoFilter } from './components/EcoFilter/EcoFilter';
import { LocalFilter } from './components/LocalFilter/LocalFilter';

import styles from './CertificationsFilters.module.scss';

interface Props {
  filtersConfigs: FilterConfig[];
  className?: string;
  filterCount?: number;
  position?: number;
}

export const CertificationsFilters: FC<Props> = ({
  filterCount,
  className,
  filtersConfigs,
  position,
}) => {
  const ecoFilterConfig = filtersConfigs.find(
    ({ attributeName }) => attributeName === 'is_eco_responsible',
  );
  const localFilterConfig = filtersConfigs.find(
    ({ attributeName }) => attributeName === 'is_local',
  );

  if (!ecoFilterConfig && !localFilterConfig) return null;

  return (
    <FilterBlock
      className={className}
      id="certifications"
      title="Label / Certification"
    >
      {ecoFilterConfig && (
        <EcoFilter
          filterConfig={ecoFilterConfig}
          className={styles.certificationFilter}
          filterCount={filterCount}
          position={position}
        />
      )}

      {localFilterConfig && (
        <LocalFilter
          filterConfig={localFilterConfig}
          className={styles.certificationFilter}
          filterCount={filterCount}
          position={position}
        />
      )}
    </FilterBlock>
  );
};
